import React, { useState, useEffect, useRef } from 'react'
import { useQuery } from '@apollo/client'
import dayjs from 'dayjs'
import { ThreadMessage } from './Thread/ThreadMessage'
import { Header } from './Header'
import { NewButton } from './UI/NewButton'
import { FooterWrapper } from './UI/Footer'
import { MESSAGE_TABS, inRange } from '../../lib/constants'

import GetRooms from './graphql/queries/getRooms.gql'

export const Messages = ({
  groupMessage,
  isOrganizer,
  switchProfile,
  userId,
  updateObj,
  panel,
  setPanel,
  setThread,
  organizationId,
  listFacilities,
  departmentId,
  setSelectedFacility,
  selectedFacility,
}) => {
  const roomsRef = useRef(null)
  const [limit, setLimit] = useState(15)
  const [totalRooms, setTotalRooms] = useState(0)
  const [data, setData] = useState([])

  const { loading } = useQuery(GetRooms, {
    fetchPolicy: 'cache-and-network',
    variables: {
      limit,
      organizationId,
      departmentId: switchProfile ? selectedFacility : departmentId,
    },
    onCompleted: ({ currentUser }) => {
      setTotalRooms(currentUser.availableRooms.pagination.totalCount)
      setData(currentUser.availableRooms.items)
    },
    skip: !organizationId,
  })

  useEffect(() => {
    if (updateObj) {
      setData((prev) => {
        const listRoom = [...prev]
        const index = listRoom.findIndex((room) => room.id === updateObj.id)
        if (index >= 0) {
          listRoom[index] = updateObj
        } else {
          listRoom.unshift(updateObj)
        }
        return listRoom
      })
    }
  }, [updateObj])

  useEffect(() => {
    const { current } = roomsRef
    const loadMore = (e) => {
      const el = e.target
      if (!loading && inRange(el.scrollTop + el.clientHeight, el.scrollHeight - 10, el.scrollHeight + 10)) {
        setLimit((prev) => prev + 10)
      }
    }
    if (data && data.length < totalRooms) {
      current.addEventListener('scroll', loadMore)
    }
    return () => {
      current.removeEventListener('scroll', loadMore)
    }
  }, [data, loading, totalRooms])

  const handleNewMessage = () => setPanel(MESSAGE_TABS.USERS)

  return (
    <>
      <div className="modal-header">
        <Header
          groupMessage={groupMessage}
          switchProfile={switchProfile}
          isOrganizer={isOrganizer}
          panel={panel}
          setPanel={setPanel}
          listFacilities={listFacilities}
          selectedFacility={selectedFacility}
          setSelectedFacility={setSelectedFacility}
        />
      </div>
      <div className="modal-body" ref={roomsRef}>
        {data.length > 0
          && [...data]
            .sort((f, l) => l.lastMessageAt && dayjs(l.lastMessageAt).diff(dayjs(f.lastMessageAt)))
            .map((room) => (
              <ThreadMessage userId={userId} setPanel={setPanel} setThread={setThread} key={room.id} room={room} />
            ))}
      </div>
      <div className="modal-footer">
        <FooterWrapper>
          <NewButton text="New Message" handler={handleNewMessage} />
        </FooterWrapper>
      </div>
    </>
  )
}
